export var FETCH_MERCHANTS_API = "/troy/user-profile/v1/merchant-selector";
export var POST_LOGIN_API = "troy/hydra-shield/v1/post-login";
export var FETCH_STORES_API = "user-profile/v2/store-list";
//# sourceMappingURL=api-endpoints.js.map